import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
export const registrationSettingsQueryKey = ['og', 'registration-settings'];
export function useRegistrationSettings(enabled = true) {
    return useQuery({
        queryKey: registrationSettingsQueryKey,
        queryFn: ({ signal }) => apiOg('users', '/api/v1/admin/registration-settings', { signal }),
        enabled,
        retry: false,
        refetchInterval: 5_000,
        refetchIntervalInBackground: false,
    });
}
export function useUpdateRegistrationSettings() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('users', '/api/v1/admin/registration-settings', {
            method: 'PUT',
            body,
        }),
        onMutate: async () => {
            await queryClient.cancelQueries({ queryKey: registrationSettingsQueryKey });
        },
        onSuccess: async (saved) => {
            await queryClient.cancelQueries({ queryKey: registrationSettingsQueryKey });
            queryClient.setQueryData(registrationSettingsQueryKey, saved);
        },
    });
}
